import { Flex, Text } from "@chakra-ui/react";
import { Button, TextField } from "@radix-ui/themes";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import { routes } from "../../routes";

export function OpenBookingByNumberForm() {
  const [bookingSlug, setBookingSlug] = useState("");
  const isBookingSlugValid = !!bookingSlug;

  return (
    <Flex direction="column" gap="12px" w="100%">
      <Text fontSize="sm" color="gray.600">
        Per Buchungsnummer öffnen
      </Text>
      <TextField.Root
        placeholder="Buchungsnummer"
        size="3"
        value={bookingSlug}
        onChange={(event) => setBookingSlug(event.target.value)}
      />
      <Button size="3" variant="soft" disabled={!isBookingSlugValid} asChild>
        <NavLink to={routes.booking(bookingSlug)}>Buchung öffnen</NavLink>
      </Button>
    </Flex>
  );
}
